import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class PromotionsProvider extends HttpRequest {
  async getPromotionsByFilterId (filterId) {
    this.setHeader(getAuthToken())
    return this.fetch(`/promotions/${filterId}/filter`)
  }

  async getPromotionById (id) {
    this.setHeader(getAuthToken())
    return this.fetch(`/promotions/${id}`)
  }

  async createPromotion (payload) {
    this.setHeader(getAuthToken())
    return this.create('/promotions', payload)
  }

  async updatePromotion (id, payload) {
    this.setHeader(getAuthToken())
    return this.update(`/promotions/${id}`, payload)
  }

  async pausePromotion (id) {
    this.setHeader(getAuthToken())
    return this.edit(`/promotions/${id}/pause`)
  }

  async restorePromotion (id) {
    this.setHeader(getAuthToken())
    return this.edit(`/promotions/${id}/restore`)
  }

  async pausePromotionsByFilterId (filterId) {
    this.setHeader(getAuthToken())
    return this.edit(`/promotions/${filterId}/pause-all`)
  }

  async restorePromotionsByFilterId (filterId) {
    this.setHeader(getAuthToken())
    return this.edit(`/promotions/${filterId}/restore-all`)
  }
}

export default PromotionsProvider
